import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useCustomReducer } from '../../../../base/customHooks'
import { IException } from '../../../../base/models'
import IPButton from '../../../../components/IPButton'
import { ISurveyReport } from './models'
import Chart from './PollListChart/ChartBar'
import Table from './PollListChart/Table'
import TableInput from './PollListChart/TableInput'
import TextAnswersView from './PollListChart/TextAnswersView'
import { GetSurveyById } from './services/getSurveyById'
import IPModal from '../../../../components/IPModal'
import { exportToXLSX } from '../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../base/customHooks/componentHOC'

interface ISurveyReportState {
  surveyReport: ISurveyReport[]
}

function PollListChart(props: BaseComponentWithContextProps) {
  const getInitialState = (): ISurveyReportState => {
    return {
      surveyReport: [],
    }
  }
  const location = useLocation()
  const intialState = getInitialState()

  const [state, setState] = useCustomReducer<ISurveyReportState>(intialState)

  useEffect(() => {
    if (location.state as any) {
      const data = _.clone((location.state as any)?.surveyData)
      props.showLoading()
      const getSurvey = new GetSurveyById({})
      getSurvey
        .getSurveyResultById(data)
        .then((res: ISurveyReport[]) => {
          props.hideLoading()
          setState({ surveyReport: res })
        })
        .catch((err: IException) => {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            allowOutsideClick: true,
          })
        })
    }
  }, [location])

  const [showModal, setShowModal] = useState<any>()
  const [modalData, setData] = useState<any>()

  //#region Excel'e aktarma

  const excelButton = async () => {
    try {
      if (!state.surveyReport || state.surveyReport.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
        return
      }

      const combinedData = state.surveyReport.flatMap((p, index) => {
        const answers = p.Answers || []
        let totalCount = 0

        const questionData = {
          Sıra: 'Soru ' + (index + 1),
          Soru: p.Text,
        }

        const answerData = answers.flatMap((modalRow, i) => {
          const answerCount = modalRow.IsInput ? 1 : modalRow.TotalCount || 0
          totalCount += answerCount

          const bayiList = Array.isArray((modalRow as any).UserList)
            ? (modalRow as any).UserList.map((u: any) => (u.DealerCode ? u.DealerCode.replace('0000', '') : ''))
              .filter((v: string) => v)
              .join(', ')
            : ''
          return [
            {
              Sıra: '',
              Soru: '',
              'Cevap No': (i + 1).toString(),
              Cevaplar: modalRow.Options,
              'Cevaplanma Sayısı': answerCount,
              'Toplam Cevaplanma Sayısı': 0,
              'Bayi Kodları (Özet)': bayiList,
            },
          ]
        })

        answerData.push({
          Sıra: '',
          Soru: '',
          'Cevap No': '',
          Cevaplar: '',
          'Cevaplanma Sayısı': 0,
          'Toplam Cevaplanma Sayısı': totalCount,
          'Bayi Kodları (Özet)': '',
        })

        return [questionData, ...answerData]
      })

      exportToXLSX(combinedData, 'Anket Sonuçları')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  // Detaylı excel (her cevap için hangi bayiler / kullanıcılar) ayrı satır mantığı
  const excelDetailButton = async () => {
    try {
      if (!state.surveyReport || state.surveyReport.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
        return
      }

      const detailedData: any[] = []
      state.surveyReport.forEach((q, qIndex) => {
        const answers = q.Answers || []
        if (answers.length === 0) return
        // Question header row
        detailedData.push({
          'Soru Sıra': qIndex + 1,
          Soru: q.Text,
          'Cevap No': '',
          Cevap: '',
          'Bayi Kodu': '',
          Kullanıcı: '',
          'Cevaplanma Sayısı': '',
        })
        answers.forEach((ans, aIndex) => {
          // AÇIK UÇLU (IsInput) CEVAPLAR: Her cevap için o cevabı veren kullanıcıyı bul
          if (ans.IsInput) {
            // Açık uçlu cevap için kullanıcı bilgilerini al
            const userList: any[] = Array.isArray((ans as any).UserList) ? (ans as any).UserList : []
            const userID = ans.UserID

            // UserID'ye göre doğru kullanıcıyı bul
            let dealerCode = ''
            let userName = ''

            if (userList.length > 0 && userID) {
              // UserID'ye göre kullanıcıyı bul
              const user = userList.find((u: any) => u.UserID === userID)
              if (user) {
                const dealerCodeRaw = user.DealerCode || ''
                dealerCode = dealerCodeRaw ? dealerCodeRaw.replace('0000', '') : ''
                userName = user.UserName || user.Username || ''
              }
            } else if (userList.length > 0) {
              // UserID yoksa ilk kullanıcıyı al
              const user = userList[0]
              const dealerCodeRaw = user.DealerCode || ''
              dealerCode = dealerCodeRaw ? dealerCodeRaw.replace('0000', '') : ''
              userName = user.UserName || user.Username || ''
            } else {
              // UserList boşsa, diğer alanlardan bilgileri almaya çalış
              const dealerCodeRaw = (ans as any).DealerCode || ''
              dealerCode = dealerCodeRaw ? dealerCodeRaw.replace('0000', '') : ''
              userName = (ans as any).UserName || (ans as any).Username || ''
            }

            detailedData.push({
              'Soru Sıra': '',
              Soru: '',
              'Cevap No': aIndex + 1,
              Cevap: ans.InputText || ans.Options,
              'Bayi Kodu': dealerCode,
              Kullanıcı: userName,
              'Cevaplanma Sayısı': 1,
            })
            return
          }

          const userList: any[] = Array.isArray((ans as any).UserList) ? (ans as any).UserList : []
          if (userList.length === 0) {
            detailedData.push({
              'Soru Sıra': '',
              Soru: '',
              'Cevap No': aIndex + 1,
              Cevap: ans.Options,
              'Bayi Kodu': '',
              Kullanıcı: '',
              'Cevaplanma Sayısı': ans.TotalCount || (ans.IsInput ? 1 : 0),
            })
          } else {
            userList.forEach((u: any, uIndex: number) => {
              detailedData.push({
                'Soru Sıra': uIndex === 0 ? '' : '',
                Soru: '',
                'Cevap No': uIndex === 0 ? aIndex + 1 : '',
                Cevap: uIndex === 0 ? ans.Options : '',
                'Bayi Kodu': u.DealerCode ? u.DealerCode.replace('0000', '') : '',
                Kullanıcı: u.UserName || u.Username || '',
                'Cevaplanma Sayısı': uIndex === 0 ? ans.TotalCount || (ans.IsInput ? 1 : 0) : '',
              })
            })
          }
        })
      })

      exportToXLSX(detailedData, 'Anket Sonuçları Detay')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }
  //#endregion

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3'>
            <div className='d-flex flex-column'>
              <span className='h4 mb-0'>Anket Sonuç Grafikleri</span>
              <small className='text-muted'>Özet ve detaylı excel indirme seçenekleri</small>
            </div>
            <div className='d-flex flex-wrap align-items-center gap-2 ms-md-auto'>
              <div className='d-flex align-items-center gap-2'>
                <span className='fw-semibold'>Excel:</span>
                <button
                  type='button'
                  style={{
                    border: '1px solid #2e7d32',
                    borderRadius: 4,
                    width: 34,
                    height: 34,
                    backgroundColor: 'white',
                  }}
                  onClick={excelButton}
                  className='btn p-0 d-flex align-items-center justify-content-center'
                  title='Özet Excel'
                >
                  <i
                    className='fas fa-file-excel'
                    style={{
                      fontSize: '18px',
                      color: '#2e7d32',
                    }}
                  ></i>
                </button>
              </div>
              <div className='d-flex align-items-center gap-2'>
                <span className='fw-semibold'>Detaylı:</span>
                <button
                  type='button'
                  style={{
                    border: '1px solid #2e7d32',
                    borderRadius: 4,
                    width: 34,
                    height: 34,
                    backgroundColor: 'white',
                  }}
                  onClick={excelDetailButton}
                  className='btn p-0 d-flex align-items-center justify-content-center'
                  title='Detaylı Excel'
                >
                  <i
                    className='fas fa-file-excel'
                    style={{
                      fontSize: '18px',
                      color: '#2e7d32',
                    }}
                  ></i>
                </button>
              </div>
              <div className='vr d-none d-md-inline' />
              <Link to='/admin/SiteReports/PollList' className='ms-md-2'>
                <IPButton type='button' className='btn btn-primary' text='Listeye Dön' />
              </Link>
            </div>
          </div>
          <div className='card-body'>
            <div className='container-wrap'>
              {state.surveyReport &&
                state.surveyReport.map((report: ISurveyReport, index) => {
                  return (
                    <div className='row' key={`${report.QuestionId}`} style={{ marginBottom: '3%' }}>
                      {index === 0 && (
                        <>
                          <h5 style={{ fontSize: 25, textAlign: 'center', backgroundColor: 'gray' }}>
                            <span style={{ marginRight: '3%' }}>Toplam Soru Sayısı: {report.QuestionCount}</span>
                            <span>
                              Katılan Bayi Sayısı:{' '}
                              {
                                <span
                                  style={{
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    marginRight: '3%',
                                  }}
                                  onClick={() => {
                                    setData(report.DealerList)
                                    setShowModal(true)
                                  }}
                                >
                                  {report.DealerCount}
                                </span>
                              }
                            </span>
                            <span>
                              Katılan Kullanıcı Sayısı:{' '}
                              {
                                <span
                                  style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                                  onClick={() => {
                                    setData(report.UserList)
                                    setShowModal(true)
                                  }}
                                >
                                  {report.UserList.length}
                                </span>
                              }
                            </span>
                          </h5>
                        </>
                      )}
                      {/* Rendering logic adjusted: 0=CheckBox,1=Radio show chart+table; 2=Input only show TableInput; 3=Checkbox+Input & 4=Radio+Input show all */}
                      {report.OptionType === 0 || report.OptionType === 1 ? (
                        <>
                          <h5 style={{ fontSize: 23 }}>{report.Text}</h5>
                          <div className='col-4'>
                            <Chart report={report} />
                          </div>
                          <div className='col-5'>
                            <Table report={report} />
                          </div>
                        </>
                      ) : report.OptionType === 3 || report.OptionType === 4 ? (
                        <>
                          <h5 style={{ fontSize: 23 }}>{report.Text}</h5>
                          <div className='col-4'>
                            <Chart report={report} />
                          </div>
                          <div className='col-5'>
                            <Table report={report} />
                          </div>
                          <div className='col-12'>
                            <TableInput report={report} />
                          </div>
                        </>
                      ) : (
                        <>
                          <h5 style={{ fontSize: 23 }}>{report.Text}</h5>
                          <div className='col-12'>
                            <TableInput report={report} />
                          </div>
                        </>
                      )}
                      {/* <div className='col-7'>
                        <TextAnswersView report={report} />
                      </div> */}
                    </div>
                  )
                })}
            </div>
            <IPModal
              show={showModal}
              onClose={() => setShowModal(false)}
              hideConfirm={true}
              width={1000}
              title={'Katılan Kullanıcılar'}
            >
              {
                <table className='table'>
                  <thead>
                    <tr role='row' className='odd'>
                      <th>#</th>
                      <th>Bayi Kodu</th>
                      <th style={{ textAlign: 'left' }}>Bayi Adı</th>
                      <th style={{ textAlign: 'left' }}>Kullanıcı</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalData &&
                      modalData.length > 0 &&
                      modalData.map((his, index) => (
                        <tr role='row' className='odd'>
                          <td style={{ width: '10%' }}>{index + 1}</td>
                          <td style={{ width: '20%' }}>{his.DealerCode && his.DealerCode.replace('0000', '')}</td>
                          <td style={{ textAlign: 'left' }}>{his.DealerName}</td>
                          <td style={{ textAlign: 'left' }}>{his.Username}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              }
            </IPModal>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(PollListChart)
